import React from 'react';
import './Footer.css';
import { CONTACT_INFO, SOCIAL_MEDIA } from '../config';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>Resume Çiğköfte</h4>
          <p>Özgün Lezzetin Adresi</p>
        </div>
        
        <div className="footer-section">
          <h4>Hızlı Linkler</h4>
          <ul>
            <li><a href="#home">Anasayfa</a></li>
            <li><a href="#products">Ürünler</a></li>
            <li><a href="#about">Hakkımızda</a></li>
            <li><a href="#contact">İletişim</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Sosyal Medya</h4>
          <div className="social-links">
            <a href={SOCIAL_MEDIA.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href={SOCIAL_MEDIA.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href={SOCIAL_MEDIA.twitter} target="_blank" rel="noopener noreferrer">Twitter</a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>İletişim</h4>
          <p>{CONTACT_INFO.phone}</p>
          <p>{CONTACT_INFO.email}</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <a 
          href="https://www.instagram.com/kanteknoloji" 
          target="_blank" 
          rel="noopener noreferrer"
          className="kanteknoloji-button"
        >
          <span className="kanteknoloji-icon">💻</span>
          <span className="kanteknoloji-text">KanteKnoloji</span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
